module.exports = __webpack_public_path__ + "static/media/res-bg.6bb1708e.jpg";